(function () {
    const header = () => {
        const body = document.querySelector("body");
        const header = document.querySelector(".shopify-section-header");
        const headerDetails = document.querySelector(".menu-drawer-container");
        const customHeaderDetails = document.querySelector(".custom-menu-drawer-container");
        const customCloseButton = document.querySelector(".custom-close-button");
        const customHeaderCloseButton = document.querySelector(".custom-header-close-button");
        const menuDrawer = document.querySelector("#menu-drawer");
        const headerIsAlwaysSticky =
            header
                .querySelector(".header-wrapper")
                .getAttribute("data-sticky-type") === "always";


        const colorScheme = menuDrawer.dataset.colorScheme;

        headerDetails.addEventListener("toggle", function (e) {
            if (menuDrawer) {
                // const colorScheme = menuDrawer.dataset.colorScheme;
                header.classList.toggle(colorScheme);
            }
        });

        customCloseButton.addEventListener("click", function (e) {
            headerDetails.open = false;
        });

        customHeaderCloseButton.addEventListener("click", function (e) {
            console.log("MP_LOG_CLICK")
            customHeaderDetails.open = false;
        });

        document.addEventListener("keyup", (e) => {
            if (e.key === "Escape") {
                header.classList.remove("shopify-section-header-sticky", "animate");
                body.classList.remove("overflow-hidden");
            }
        });

        document.addEventListener("scroll", () => {
            let scrollTop = window.scrollY;
            if (scrollTop > header.offsetHeight && headerIsAlwaysSticky) {
                header.classList.add("fixed", "animate");
            } else if (scrollTop <= header.offsetHeight && headerIsAlwaysSticky) {
                header.classList.remove("fixed", "animate");
            }
        });
        const headerAllDetails = document.querySelectorAll(".header details");
        headerAllDetails.forEach((details) => {
            details.addEventListener("click", function (e) {
                if (window.matchMedia("(max-width: 1099px)").matches) return false;
                const disclosureList = document.querySelectorAll(
                    ".header .disclosure__list"
                );
                disclosureList.forEach((list) => {
                    if (list.hasAttribute("hidden")) return;
                    list.setAttribute("hidden", "true");
                    list.previousElementSibling.setAttribute("aria-expanded", "false");
                });
            });
        });

        if (header && header.classList.contains("color-background-overlay")) {
            header.addEventListener("mouseenter", () => {
                header.classList.remove("color-background-overlay");
                header.classList.add("color-background-overlay-hidden");
            });

            header.addEventListener("mouseleave", () => {
                header.classList.add("color-background-overlay");
                header.classList.remove("color-background-overlay-hidden");
            });
        }
    };
    document.addEventListener("shopify:section:load", header);
    document.addEventListener("shopify:section:unload", header);
    document.addEventListener("shopify:section:reorder", header);

    header();
})();
